export default __webpack_public_path__ + "static/media/FED77AE3-6BF3-4761-A276-33D2081DF54E_1_105_c.58f63fa6.jpg";